export default {
  /**
   * Sets the data onto the state for a new local modal to be displayed.
   *
   * @param {Function} commit
   * @param {Object|null} targetElement
   * @param {Object|null} contentComponent
   * @param {Object|null} maskComponent
   * @param {String} attachment
   * @param {String} targetAttachment
   * @param {String} colour
   * @return {Promise}
   */
  open(
    { commit },
    {
      targetElement,
      contentComponent,
      direction,
      width,
      maskComponent = null,
      colour = 'white',
      componentData = null,
      customClass = '',
    },
  ) {
    let attachment
    let targetAttachment

    switch (direction) {
      case 'up':
        attachment = 'bottom center'
        targetAttachment = 'top center'
        break
      case 'right':
        attachment = 'middle left'
        targetAttachment = 'middle right'
        break
      case 'down':
        attachment = 'top center'
        targetAttachment = 'bottom center'
        break
      case 'left':
        attachment = 'middle right'
        targetAttachment = 'middle left'
        break
      default:
        throw new Error(`Unknown direction '${direction}' provided`)
    }

    return commit('SET_VALUES', {
      targetElement,
      contentComponent,
      maskComponent,
      attachment,
      targetAttachment,
      colour,
      width,
      componentData,
      customClass,
    })
  },

  /**
   * Closes the local modal by setting all values to null.
   *
   * @param {Function} commit
   * @return {Promise}
   */
  close({ commit }) {
    return commit('SET_VALUES', {})
  },
}
